import {
	Button,
	Checkbox,
	Dialog,
	DialogContent,
	IconButton,
	Paper,
	Slide,
	Toolbar,
	Typography,
	createTheme,
	useMediaQuery,
} from "@mui/material"
import { forwardRef } from "react"
import CloseIcon from "@mui/icons-material/Close"
import { adminSavePostColumnsSettings } from "../util/firebase"

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />
})

const mdTheme = createTheme({
	palette: {
		primary: {
			main: "#132242",
		},
		secondary: {
			main: "#DF0A0A",
		},
		white: {
			main: "white",
		},
	},
})

const PostColumnChooser = ({ postColumnChooserOpen, setPostColumnChooserOpen, postCols, setPostCols }) => {
	const matches = useMediaQuery(mdTheme.breakpoints.up("md"))

	const handleClose = async () => {
		await adminSavePostColumnsSettings({ adminPostColumnSettings: postCols })
		setPostColumnChooserOpen(false)
	}

	return (
		<Dialog
			fullScreen={!matches}
			open={postColumnChooserOpen}
			onClose={() => setPostColumnChooserOpen(false)}
			TransitionComponent={Transition}
			PaperProps={{
				style: {
					backgroundColor: "white",
					maxHeight: "715px",
				},
			}}
			maxWidth={"md"}
			/* scroll="body" */
			/* sx={{ maxHeight: "715px"}} */
		>
			<Toolbar>
				<IconButton edge="start" color="inherit" onClick={() => setPostColumnChooserOpen(false)} aria-label="close">
					<CloseIcon />
				</IconButton>
				<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
					בחירת עמודות
				</Typography>
			</Toolbar>
			<DialogContent dividers>
				<Paper
					sx={{
						p: 2,
						display: "flex",
						flexDirection: "column",
						justifyContent: "flex-start",
						flexWrap: "wrap",
					}}
				>
					{postCols.map((col, index) => (
						<div key={col.field}>
							<Checkbox
								checked={col.display}
								onChange={(e) => {
									if (e.target.checked) {
										setPostCols((prevState) =>
											prevState.map((e) => (e.field === col.field ? { ...e, display: true } : e))
										)
									} else {
										setPostCols((prevState) =>
											prevState.map((e) => (e.field === col.field ? { ...e, display: false } : e))
										)
									}
								}}
							/>
							<span>{col.label}</span>
						</div>
					))}
				</Paper>
				<Button
					sx={{ backgroundColor: mdTheme.palette.primary.main, width: matches ? "120px" : "auto", mt: 2, mb: 2 }}
					onClick={() => handleClose()}
					variant="contained"
				>
					שמירה
				</Button>
			</DialogContent>
		</Dialog>
	)
}

export default PostColumnChooser
